import { WithChildren } from "helpers";
import React, { FC } from "react";

const FilterButtonLayout: FC<WithChildren> = ({ children }) => {
  return (
    <div style={{ marginTop: "1px" }} className="d-flex align-content-center ">
      <div>{children}</div>
    </div>
  );
};

export default FilterButtonLayout;
